
  import FacultyDetail from "@/components/FacultyDetail.vue";
  import { Vue, Component } from "vue-property-decorator";

  @Component({
    components: {
      FacultyDetail,
    },
  })
  export default class GiselleCarnaby extends Vue {
    giselle = {
      name: "Giselle Carnaby",
      image: require("@/assets/faculty-giselle.png"),
      title: "MPH, Ph.D, FASHA, Honors ASHA, CCC&#8209;SLP",
      description:
        "Professor in Health Sciences at the University of Texas San Antonio Health Sciences Center. As a Speech- Language Pathologist and Public Health Specialist she specializes in research epidemiology and biostatistics and has worked extensively in neurology and dysphagia research. Dr Carnaby’s research focus lies in the rehabilitation of swallowing disorders in head neck cancer, stroke, and Parkinson’s disease. She has published over 130 peer reviewed papers in these areas. Dr. Carnaby is the author of the “Mann Assessment of Swallowing” and its cancer version MASA-C. She is a lifetime research scholar of the American Cancer Society and has a background of funded research from the NIH-NCI, NIH-NICHD, ACS, FL- DOH, and the DOD. She was awarded ASHA Fellow, in 2012 and received Honors of the Association in 2020.",
    };
  }
